import { MaterialIcon, Texto, Horizontal } from '@gravitate-js/excalibrr'
import * as React from 'react'

/**
 * Cell renderer for customer column
 * Shows customer name with store icon
 */
export function CustomerRenderer(params: any) {
  return (
    <Horizontal style={{ overflow: 'visible' }} gap={8} verticalCenter>
      <MaterialIcon icon='store' style={{ color: 'var(--theme-color-2)' }} />
      <Texto>{params.value || 'N/A'}</Texto>
    </Horizontal>
  )
}
